module.exports = __webpack_public_path__ + "img/homepage_banner.0a91446b.jpg";